import da from 'date-fns/locale/da';
import format from 'date-fns/format';
import subMonths from 'date-fns/subMonths';
import startOfYear from 'date-fns/startOfYear';

export type DateRange = {
  from: Date;
  to: Date;
};

const defaultOptions = { locale: da };

export const formatDate = (date: Date, dateFormat: string): string => format(
  date,
  dateFormat,
  defaultOptions
);

export const getDateRange = (type: 'month' | 'half_year' | 'year' | 'year_to_date'): DateRange => {
  const date = new Date();

  switch (type) {
    case 'month':
      return { from: subMonths(date, 1), to: date };
    case 'half_year':
      return { from: subMonths(date, 6), to: date };
    case 'year':
      return { from: subMonths(date, 12), to: date };
    case 'year_to_date':
      return { from: startOfYear(date), to: date };
    default:
      throw new Error('Invalid range type');
  }
};



// WEBPACK FOOTER //
// ./src/utils/dateUtils.ts